<div
  class="container"
  [class.white]="appearance === 'white' || !appearance"
  [class.transparent]="appearance === 'transparent'"
  [class.color]="appearance === 'color'"
  [class.compact]="size === 'compact'"
  prlwResponsive
>
  <ng-content></ng-content>
</div>
